import { ellipsisAddress } from '../utils/format'
import { useState, useEffect } from 'react'

interface AddressProps {
  address: string
  ellipsis?: boolean
  size?: 'sm' | 'md'
}

export default function Address({ address, ellipsis = false, size = 'md' }: AddressProps) {
  const [width, setWidth] = useState(typeof window !== 'undefined' ? window.innerWidth : 1024)
  const characters = size === 'md' ? 6 : size === 'sm' ? 4 : 6

  useEffect(() => {
    const handleResize = () => setWidth(window.innerWidth)
    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [])

  if (ellipsis) {
    return <>{ellipsisAddress(address, characters, width < 768)}</>
  }

  return <>{address}</>
}

